import { Film, CheckCircle2, AlertCircle, Loader2 } from "lucide-react";

/** Small "Generating/Ready" pill shown on property cards/rows so agents and
 * admins see Rendy video progress without opening the edit modal. */
export function RendyVideoStatusBadge({ status, progress, className = "" }) {
  if (!status) return null;

  const configByStatus = {
    generating: {
      label: progress ? `Generating ${progress}%` : "Generating",
      icon: Loader2,
      spin: true,
      cls: "bg-amber-100 text-amber-800 border-amber-200",
    },
    exporting: {
      label: "Exporting",
      icon: Loader2,
      spin: true,
      cls: "bg-amber-100 text-amber-800 border-amber-200",
    },
    ready: {
      label: "Video Ready",
      icon: CheckCircle2,
      spin: false,
      cls: "bg-green-100 text-green-800 border-green-200",
    },
    failed: {
      label: "Video Failed",
      icon: AlertCircle,
      spin: false,
      cls: "bg-red-50 text-red-700 border-red-200",
    },
  };

  const cfg = configByStatus[status] || {
    label: status,
    icon: Film,
    spin: false,
    cls: "bg-slate-100 text-slate-700 border-slate-200",
  };
  const Icon = cfg.icon;

  return (
    <span
      className={`inline-flex items-center gap-1 text-[9px] font-medium px-1.5 py-0.5 rounded-full border whitespace-nowrap ${cfg.cls} ${className}`}
      data-testid={`rendy-video-status-badge-${status}`}
      title={`Rendy video: ${cfg.label}`}
    >
      <Icon size={10} className={cfg.spin ? "animate-spin" : ""} />
      {cfg.label}
    </span>
  );
}

export default RendyVideoStatusBadge;
